import { addCountryCode, getLocationString } from '@react/data-hub/helpers';
import { InsightsFilters, MetaData } from '@react/data-hub/types/misc';
import { usePrefetch } from '@react/services/api';
import { useEffect, useState } from 'react';

export default function useSearchInsights({
  filters,
}: {
  filters: InsightsFilters;
}) {
  const { toc, state, city, roomType, include } = filters;

  const apiFilters = {
    'care-type': toc,
    'filter[state]': state,
    'filter[city]': city,
    'filter[room-type]': roomType,
    include,
  };

  const {
    requestInfo: { normalized, hasFinished, isLoading, meta: metaData },
    // fetch,
  } = usePrefetch('getSearchInsights', apiFilters, {
    shouldBail: !(toc && city && state && roomType),
  });

  const [searchInsights, setSearchInsights] = useState(() => normalized);
  const [metadata, setMetadata] = useState<MetaData | null>(
    () => metaData as MetaData | null
  );

  useEffect(() => {
    if (hasFinished) {
      setSearchInsights(normalized);
      if (metaData) {
        setMetadata(metaData as MetaData);
      }
    }
  }, [normalized, hasFinished, metaData]);

  const locationString = searchInsights
    ? getLocationString({
        type: searchInsights.type,
        name: searchInsights.name,
        stateName: searchInsights.stateName,
      })
    : '';

  const locationStringWithCountryCode = addCountryCode(locationString);

  return {
    searchInsights,
    isLoading,
    locationString,
    locationStringWithCountryCode,
    metadata,
  };
}
